<template>
  <div class="audiopreview-wrapper" :style="`background:url(${backgroundUrlPath})`">
      <audio class="audiopreview-video-element" controls autoplay name="media">
          <source :src="fileUrl"/>
      </audio>
  </div>
</template>

<script>
export default {
   name:'AudioFilePreview',
   props:['url','backgroundUrl'],
   data(){
      return {
          fileUrl:'',
          backgroundUrlPath:'',
      }
  },
  mounted(){
      this.fileUrl = this.url;
      this.backgroundUrlPath = this.backgroundUrl;
  }
}
</script>

<style>
  .audiopreview-video-element{
    position: absolute;
    top: 0px;
    inset-inline-end: 0px;
    bottom: 0px;
    inset-inline-start:0px;
    max-height: 100%;
    max-width: 100%;
    margin: auto;
    user-select: none;
  }
  .audiopreview-wrapper{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat !important;
    background-position: center 154px !important;
    object-fit: cover !important;
  }
</style>